import { render, staticRenderFns } from "./CompCompetitions.vue?vue&type=template&id=0edab675&scoped=true"
import script from "./CompCompetitions.vue?vue&type=script&lang=js"
export * from "./CompCompetitions.vue?vue&type=script&lang=js"
import style0 from "./CompCompetitions.vue?vue&type=style&index=0&id=0edab675&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edab675",
  null
  
)

export default component.exports